var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-template",class:{
	disabled: !_vm.show,
}},[_c('transition',{attrs:{"name":"backdrop-animation"}},[(_vm.show)?_c('div',{staticClass:"backdrop"}):_vm._e()]),_c('transition',{attrs:{"name":_vm.transition}},[(_vm.show)?_c('div',{ref:"content",staticClass:"content",class:{active: _vm.show},on:{"click":_vm.close}},[_vm._t("default")],2):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }